import React from 'react'

import { useT } from '../i18n'

// Findings #200 / #206: records of a deleted lot are kept but hidden behind a
// "Mostrar" line (Base de datos, Agua, Alimentación). Shown, they are greyed
// and read-only; Lotes → Lotes eliminados → Restaurar brings the lot back.

export const DELETED_LOT_ROW_STYLE: React.CSSProperties = { opacity: 0.55 }

export default function DeletedLotRowsLine({ count, shown, onToggle, testId }: {
  count: number
  shown: boolean
  onToggle: () => void
  testId: string
}): React.ReactElement | null {
  const t = useT()
  if (count <= 0) return null
  return (
    <div data-testid={testId} style={{ padding: '8px 12px', fontSize: 13, color: '#475569', background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
      {count === 1
        ? t(shown ? 'datatable.deletedLot.shownOne' : 'datatable.deletedLot.hiddenOne')
        : t(shown ? 'datatable.deletedLot.shown' : 'datatable.deletedLot.hidden', { count })}{' '}
      <button
        type="button"
        onClick={onToggle}
        style={{ border: 'none', background: 'none', color: '#1d4ed8', cursor: 'pointer', textDecoration: 'underline', padding: 0, fontSize: 13 }}
        data-testid={`${testId}-toggle`}
      >
        {t(shown ? 'datatable.emptyRows.hide' : 'datatable.emptyRows.show')}
      </button>
    </div>
  )
}
